// extracted by mini-css-extract-plugin
export var layoutContainer = "_dj-0";
export var layoutContainerNoRounding = "_dj-6";
export var layoutContainerOpen = "_dj-5";
export var layoutContainerResizing = "_dj-1";
export var mainContent = "_dj-2";
export var resizeDivider = "_dj-3";
export var slidePanel = "_dj-4";